import React from 'react';
import { Box, Chip, IconButton, Paper, Stack, Typography, useTheme } from '@mui/material';
import { FileManagementTable } from './FileManagementTable';
import { FiChevronDown, FiChevronRight, FiShare2, FiTrash } from 'react-icons/fi'
import { getDatasetPermission, extractDatasetName } from './DatasetHelper';
import { getChipColor } from '../../Utils/classification_helper.js';

export const GroupContainer = ({ 
  index,
  group,
  openFiles,
  datasetPermissions,
  setOpenFiles,
  openDatasets,
  setOpenDatasets,
  selectedFiles,
  setSelectedFiles,
  setDataSetToDelete,
  setDatasetToShare,
  refetch,
  default_data,
  getToken
}) => {
  const theme = useTheme();
  const open = openDatasets.includes(group.source);

  const setOpen = () => {
    setOpenDatasets(
      openDatasets.includes(group.source) ? openDatasets.filter((dataset) => dataset !== group.source) : [...openDatasets, group.source]
    );
  }

  const getClassification = (dataset) => {
    const datasetPermission = datasetPermissions.find((permission) => permission.dataset === dataset);
    return datasetPermission ? datasetPermission.classification : null;
  }

  const classification = getClassification(group.source);

  return (
    <Paper key={index} sx={{ padding: 1, marginBottom: 2, backgroundColor: theme.palette.table.groupBackground, boxShadow: 'none' }}>
      <Stack direction="row" spacing={2} alignItems="center">
        <IconButton
          aria-label="expand row"
          size="small"
          onClick={() => setOpen(!open)}
          disabled={group.files.length === 0}
        >
          {open ? <FiChevronDown /> : <FiChevronRight />}
        </IconButton>
        <Typography size={16} fontWeight={'bold'}>{extractDatasetName(group.source)}</Typography>
        { default_data.default_hide_cac !== true && classification ?
            <Chip
              label={classification}        // keep the label
              size="small"
              style={{
                backgroundColor: getChipColor(classification),
                color: '#fff'               // ensure text is readable
              }}
            /> : ''
        }
        <Typography fontSize={14} >{`${group.files.length} Files`}</Typography>
        <Stack direction="row" spacing={0.5}>
          { getDatasetPermission(group.source, datasetPermissions) === 'owner' && (
            <IconButton
              aria-label='delete'
              size='small'
              onClick={()=> {
                setDataSetToDelete(group.source);
              }}
            >
              <FiTrash/>
            </IconButton>
          )}
          { (getDatasetPermission(group.source, datasetPermissions) === 'owner' || getDatasetPermission(group.source, datasetPermissions) === 'admin') && (
            <IconButton
              aria-label='share dataset'
              size='small'
              onClick={()=> {
                setDatasetToShare(group.source);
              }}
            >
              <FiShare2/>
            </IconButton>
          )}
        </Stack>
      </Stack>
      {open && (
        <Box sx={{ padding: 1 }}>
          <FileManagementTable
            datasetPermissions={datasetPermissions}
            data={group.files}
            fetching={false}
            groupDatasets={true}
            openFiles={openFiles}
            setOpenFiles={setOpenFiles}
            selectedFiles={selectedFiles}
            setSelectedFiles={setSelectedFiles}
            refetch={refetch}
            default_data={default_data}
            getToken={getToken}
          />
        </Box>
      )}
    </Paper>
  );
}
